export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore()
  if (to.meta.auth && !authStore.isInRoles(to.meta.auth.roles) && !to.path.startsWith('/public')) {
    console.error('unauthorized for navigation', to.meta.auth.roles)
    return abortNavigation()
  }
  return
})
